import { render, staticRenderFns } from "./InternalServerErrorRequestDetails.vue?vue&type=template&id=72e1a2f1&"
import script from "./InternalServerErrorRequestDetails.vue?vue&type=script&lang=ts&"
export * from "./InternalServerErrorRequestDetails.vue?vue&type=script&lang=ts&"
import style0 from "./InternalServerErrorRequestDetails.vue?vue&type=style&index=0&id=72e1a2f1&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports